var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1716_4090",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1716_4090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.007 17.0837C9.02418 17.0837 8.10327 16.8978 7.24424 16.526C6.38522 16.1541 5.63626 15.6488 4.99737 15.0099C4.35848 14.371 3.8532 13.6221 3.48154 12.763C3.10973 11.9041 2.92383 10.9832 2.92383 10.0003C2.92383 9.01741 3.10973 8.09651 3.48154 7.23762C3.8532 6.37859 4.35848 5.62963 4.99737 4.99074C5.63626 4.35185 6.38522 3.84651 7.24424 3.4747C8.10327 3.1029 9.02418 2.91699 10.007 2.91699C11.0551 2.91699 12.0509 3.13734 12.9942 3.57803C13.9376 4.01873 14.7474 4.6381 15.4236 5.43616V3.46178H16.6736V7.69262H12.443V6.44262H14.6224C14.0476 5.73428 13.3623 5.17796 12.5663 4.77366C11.7704 4.36921 10.9172 4.16699 10.007 4.16699C8.38195 4.16699 7.00348 4.73296 5.87154 5.86491C4.73959 6.99685 4.17362 8.37533 4.17362 10.0003C4.17362 11.6253 4.73959 13.0038 5.87154 14.1357C7.00348 15.2677 8.38195 15.8337 10.007 15.8337C11.4653 15.8337 12.737 15.3601 13.822 14.413C14.907 13.466 15.5547 12.2728 15.7651 10.8337H17.0407C16.8376 12.6242 16.0658 14.1135 14.7251 15.3016C13.3842 16.4896 11.8115 17.0837 10.007 17.0837ZM12.4847 13.3562L9.38216 10.2535V5.83366H10.632V9.7472L13.3628 12.4778L12.4847 13.3562Z",
    fill: "#342E37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.d91ddb45969a265944b95a305b7d5030.svg";
export { ForwardRef as ReactComponent };